<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-12.mb-1
        SubmitButton(
          icon="fa fa-search"
          :loading="loading"
          :text="$t('ui.search')"
          type="button"
          @click="getWinLose(true)"
          variant="primary"
          size="sm"
        ).mr-2
        jsonToExcel(v-if="winloseList.length > 0" mode="PlatformWinlose" tbl="tblListPlatformWinlose" :date="dateRange")
        platformWinloseExport(v-if="winloseList.length > 0" :tbl="winloseList" :totalTbl="grandTotalList" tblId="tblListPlatformWinlose")
  .card-body
    .row
      //- .col-10.mb-1
      //-   b-pagination.float-left(
      //-     size="sm"
      //-     hide-ellipsis
      //-     :total-rows="totalRow"
      //-     :per-page="getPageSize"
      //-     v-model="currentPage"
      //-     @input="changedPage($event)")
      //- .col-2.mb-1
      //-   b-input-group(:prepend="$t('ui.page_size')" size="sm")
      //-     b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12(style="max-height: 70vh; overflow: hidden;")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover#tblListPlatformWinlose
            thead.thead-light
              tr
                th(width="10%")
                  span(:title="$t('ui.category')") {{ $t('ui.category') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                th.text-right(width="15%")
                  span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
            tbody.clusterize-content
              tr(v-if="winloseList.length == 0")
                td(colspan="3").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in winloseList")
                td
                  span(:title="item.category") {{ item.category }}&nbsp;
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                td.text-right
                  //- TEMP HIDE
                  //- span.font-weight-bold(v-if="showActionButton(item.category)")
                  //-   b-link(href="javascript:void(0);" @click="redirectToGR(item)" :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                  //- span.font-weight-bold(v-else :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                  span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
              tr(v-if="showTotal")
                td.text-right
                  span {{ $t("ui.sub_total") }}
                  br
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
// import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcel.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import platformWinloseExport from "@/components/report/platformWinloseExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    platformWinloseExport
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    grandTotalList: [],
    winloseList: [],
    // currentPage: 1,
    // totalRow: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    }
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberReport;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
  },
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null
    };

    this.$store.dispatch("user/setWinLoseParam", json);
  },
  methods: {
    refresh() {
      if (this.$store.getters.winLose.start_date && this.$store.getters.winLose.end_date) {
        this.dateRange.startDate = this.$store.getters.winLose.start_date;
        this.dateRange.endDate = this.$store.getters.winLose.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getWinLose();
    },
    showActionButton(category) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var action = '';
          if (category.trim().toUpperCase() == 'SLOTS')
            action = 'gameresultslots';
          else if (category.trim().toUpperCase() == 'LIVECASINO')
            action = 'gameresultlivecasino';
          else if (category.trim().toUpperCase() == 'REBATE')
            action = 'gameresultrebate';
          else if (category.trim().toUpperCase() == 'SPORTSBOOK')
            action = 'gameresultsportsbook';
          else if (category.trim().toUpperCase() == 'COCKFIGHT')
            action = 'gameresultcockfight';
          else if (category.trim().toUpperCase() == 'RESCUE')
            action = 'gameresultrescue';
          else if (category.trim().toUpperCase() == 'OTHERS')
            action = 'gameresultothers';

          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.currentPage = 1;
      this.getWinLose();
    },
    redirectToGR: function(item) {
      var start_date;
      var end_date;

      if (['SLOTS','LIVECASINO', 'COCKFIGHT', 'OTHERS'].includes(item.category.trim().toUpperCase())) {
        start_date = this.$moment(this.dateRange.startDate).format('YYYY-MM-DD 00:00:00');
        end_date = this.$moment(this.dateRange.endDate).format('YYYY-MM-DD 23:59:59');
      }
      else {
        start_date = this.dateRange.startDate;
        end_date = this.dateRange.endDate;
      }

      // var json = { account_id: item.account_id, start_date: this.dateRange.startDate, end_date: this.dateRange.endDate };
      var json = { account_id: item.account_id, start_date: start_date, end_date: end_date, rebate_type: null, provider: null, table_id: null, rescue_type: null };

      this.$store.dispatch("user/setGameResultParam", json);

      if (item.category.trim().toUpperCase() == 'SLOTS')
        this.$router.push("/report/gameResultSlots");
      else if (item.category.trim().toUpperCase() == 'LIVECASINO')
        this.$router.push("/report/gameResultLivecasino");
      else if (item.category.trim().toUpperCase() == 'REBATE')
        this.$router.push("/report/gameResultRebate");
      else if (item.category.trim().toUpperCase() == 'SPORTSBOOK')
        this.$router.push("/report/gameResultSportsbook");
      else if (item.category.trim().toUpperCase() == 'COCKFIGHT')
        this.$router.push("/report/gameResultCockfight");
      else if (item.category.trim().toUpperCase() == 'RESCUE')
        this.$router.push("/report/gameResultRescue");
      else if (item.category.trim().toUpperCase() == 'OTHERS')
        this.$router.push("/report/gameResultOthers");
    },
    setPlatformWinLoseParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
      };
      this.$store.dispatch("user/setWinLoseParam", json);
    },
    getWinLose: function() {
      if (this.checkDateRange()) {
        if (this.operatorID.trim() == '') {
          this.clearTotal();
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
          return;
        }
        if (this.memberID.trim() == '') {
          this.clearTotal();
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.memberIdRequired"), "error");
          return;
        }

        this.setPlatformWinLoseParam();

        let url = config.platformWinLoseUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID.trim(),
          member_id: this.memberID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.winlose.length > 0) {
                    this.showTotal = true
                    response.data.ds.winlose.forEach(value => {
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                    }

                    this.grandTotalList = response.data.ds.grand_total
                    this.winloseList = response.data.ds.winlose
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.winloseList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false;
      this.winloseList = []
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
    },
    // changedPageSize: function(pageSize) {
    //   if(this.currTab != 'platformwinlose') return
    //   this.$store.dispatch("layout/setPageSizeMemberReport", pageSize);
    //   this.currentPage = 1;
    //   this.getWinLose();
    // },
    // changedPage: function(pageNo) {
    //   this.currentPage = pageNo;
    //   this.getWinLose();
    // },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>